import { render, staticRenderFns } from "./ModalSetupProfile.vue?vue&type=template&id=1bddbc6c&"
import script from "./ModalSetupProfile.vue?vue&type=script&lang=js&"
export * from "./ModalSetupProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports